import androidx.compose.runtime.CompositionLocalProvider
import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.navigation.BasePath
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.navigation.remove
import com.varabyte.kobweb.silk.defer.DeferringHost
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.renderComposable

public fun main() {
    AppGlobals.initialize(mapOf("title" to "Meeting Genie"))
    BasePath.set("")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.register("/") { gr.tech.meetinggenie.pages.IndexPage() }
        ctx.router.register("/login") { gr.tech.meetinggenie.pages.UserLoginPage() }
        ctx.router.register("/meeting/{id}") { gr.tech.meetinggenie.pages.MeetingPage() }
        ctx.router.register("/meetings") { gr.tech.meetinggenie.pages.MeetingListPage() }

    }
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    com.varabyte.kobweb.silk.init.additionalSilkInitialization = { ctx ->
        com.varabyte.kobweb.silk.init.initSilkWidgets(ctx)
        com.varabyte.kobweb.silk.init.initSilkWidgetsKobweb(ctx)
        ctx.theme.registerStyle("page-content", gr.web.icyleds.components.layouts.PageContentStyle)
        ctx.theme.registerStyle("copy-string-box",
                gr.tech.meetinggenie.components.widgets.CopyStringBoxStyle)
        ctx.theme.registerStyle("copy-container",
                gr.tech.meetinggenie.components.widgets.CopyContainerStyle)
        ctx.theme.registerStyle("copied-overlay-base",
                gr.tech.meetinggenie.components.widgets.CopiedOverlayBase)
        ctx.theme.registerStyle("copied-overlay-hidden",
                gr.tech.meetinggenie.components.widgets.CopiedOverlayHidden)
        ctx.theme.registerStyle("copied-overlay-visible",
                gr.tech.meetinggenie.components.widgets.CopiedOverlayVisible)
        ctx.theme.registerStyle("simple-span", gr.tech.meetinggenie.styles.SimpleSpanStyle)
        ctx.theme.registerStyle("page-title", gr.tech.meetinggenie.styles.PageTitleStyle)
        ctx.theme.registerStyle("page-subtitle", gr.tech.meetinggenie.styles.PageSubtitleStyle)
        ctx.theme.registerStyle("list-page-title", gr.tech.meetinggenie.styles.ListPageTitleStyle)
        ctx.theme.registerStyle("section-heading", gr.tech.meetinggenie.styles.SectionHeadingStyle)
        ctx.theme.registerStyle("sub-section-heading",
                gr.tech.meetinggenie.styles.SubSectionHeadingStyle)
        ctx.theme.registerStyle("modal-title", gr.tech.meetinggenie.styles.ModalTitleStyle)
        ctx.theme.registerStyle("modal-subtitle", gr.tech.meetinggenie.styles.ModalSubtitleStyle)
        ctx.theme.registerStyle("login-title", gr.tech.meetinggenie.styles.LoginTitleStyle)
        ctx.theme.registerStyle("simple-grid-gap", gr.tech.meetinggenie.styles.SimpleGridGapStyle)
        ctx.theme.registerStyle("tooltip-icon", gr.tech.meetinggenie.styles.TooltipIconStyle)
        ctx.theme.registerStyle("tool-tip", gr.tech.meetinggenie.styles.ToolTipStyle)
        ctx.theme.registerStyle("tool-tip-text", gr.tech.meetinggenie.styles.ToolTipTextStyle)
        ctx.theme.registerStyle("table-cell-text", gr.tech.meetinggenie.styles.TableCellTextStyle)
        ctx.theme.registerStyle("table-cell-bold-text",
                gr.tech.meetinggenie.styles.TableCellBoldTextStyle)
        ctx.theme.registerStyle("form-label", gr.tech.meetinggenie.styles.FormLabelStyle)
        ctx.theme.registerStyle("error-text", gr.tech.meetinggenie.styles.ErrorTextStyle)
        ctx.theme.registerStyle("error-page", gr.tech.meetinggenie.styles.ErrorPageStyle)
        ctx.theme.registerStyle("save-status", gr.tech.meetinggenie.styles.SaveStatusStyle)
        ctx.theme.registerStyle("submitted-badge", gr.tech.meetinggenie.styles.SubmittedBadgeStyle)
        ctx.theme.registerStyle("response-status-badge",
                gr.tech.meetinggenie.styles.ResponseStatusBadgeStyle)
        ctx.theme.registerStyle("response-preview",
                gr.tech.meetinggenie.styles.ResponsePreviewStyle)
        ctx.theme.registerStyle("response-card", gr.tech.meetinggenie.styles.ResponseCardStyle)
        ctx.theme.registerStyle("content-card", gr.tech.meetinggenie.styles.ContentCardStyle)
        ctx.theme.registerStyle("table-container", gr.tech.meetinggenie.styles.TableContainerStyle)
        ctx.theme.registerStyle("modal-card", gr.tech.meetinggenie.styles.ModalCardStyle)
        ctx.theme.registerStyle("modal-overlay", gr.tech.meetinggenie.styles.ModalOverlayStyle)
        ctx.theme.registerStyle("modal-content-animation",
                gr.tech.meetinggenie.styles.ModalContentAnimation)
        ctx.theme.registerStyle("close-icon", gr.tech.meetinggenie.styles.CloseIconStyle)
        ctx.theme.registerStyle("login-page", gr.tech.meetinggenie.styles.LoginPageStyle)
        ctx.theme.registerStyle("login-card", gr.tech.meetinggenie.styles.LoginCardStyle)
        ctx.theme.registerStyle("google-sign-in-button",
                gr.tech.meetinggenie.styles.GoogleSignInButtonStyle)
        ctx.theme.registerStyle("google-sign-in-icon",
                gr.tech.meetinggenie.styles.GoogleSignInIconStyle)
        ctx.theme.registerStyle("button", gr.tech.meetinggenie.styles.ButtonStyle)
        ctx.theme.registerStyle("white-button", gr.tech.meetinggenie.styles.WhiteButtonStyle)
        ctx.theme.registerStyle("secondary-button",
                gr.tech.meetinggenie.styles.SecondaryButtonStyle)
        ctx.theme.registerStyle("general-button", gr.tech.meetinggenie.styles.GeneralButtonStyle)
        ctx.theme.registerStyle("show-more-button", gr.tech.meetinggenie.styles.ShowMoreButtonStyle)
        ctx.theme.registerStyle("medium-green-hover-link",
                gr.tech.meetinggenie.styles.MediumGreenHoverLink)
        ctx.theme.registerStyle("dropdown-column", gr.tech.meetinggenie.styles.DropdownColumnStyle)
        ctx.theme.registerStyle("dropdown-option", gr.tech.meetinggenie.styles.DropdownOptionStyle)
        ctx.theme.registerStyle("table-header", gr.tech.meetinggenie.styles.TableHeaderStyle)
        ctx.theme.registerStyle("table-row-hover", gr.tech.meetinggenie.styles.TableRowHoverStyle)
        ctx.theme.registerStyle("table-row-button", gr.tech.meetinggenie.styles.TableRowButtonStyle)
        ctx.theme.registerStyle("base-table", gr.tech.meetinggenie.styles.BaseTableStyle)
        ctx.theme.registerStyle("input-label", gr.tech.meetinggenie.styles.InputLabelStyle)
        ctx.theme.registerStyle("text-input", gr.tech.meetinggenie.styles.TextInputStyle)
        ctx.theme.registerStyle("string-input", gr.tech.meetinggenie.styles.stringInputStyle)
        ctx.theme.registerStyle("prop-derivative-label",
                gr.tech.meetinggenie.styles.PropDerivativeLabelStyle)
        ctx.theme.registerStyle("prop-derivative-span",
                gr.tech.meetinggenie.styles.PropDerivativeSpanStyle)
        ctx.theme.registerStyle("radio-label", gr.tech.meetinggenie.styles.RadioLabelStyle)
        ctx.theme.registerStyle("home-page", gr.tech.meetinggenie.styles.HomePageStyle)
        ctx.theme.registerStyle("home-header", gr.tech.meetinggenie.styles.HomeHeaderStyle)
        ctx.theme.registerStyle("input-container", gr.tech.meetinggenie.styles.InputContainerStyle)
        ctx.theme.registerStyle("general-input-label",
                gr.tech.meetinggenie.styles.GeneralInputLabelStyle)
        ctx.theme.registerStyle("general-input", gr.tech.meetinggenie.styles.GeneralInputStyle)
        ctx.theme.registerStyle("general-text-area",
                gr.tech.meetinggenie.styles.GeneralTextAreaStyle)
        ctx.theme.registerStyle("general-form-error-text",
                gr.tech.meetinggenie.styles.GeneralFormErrorTextStyle)
        ctx.theme.registerStyle("general-input-error",
                gr.tech.meetinggenie.styles.GeneralInputErrorStyle)
        ctx.theme.registerStyle("radio-group-container",
                gr.tech.meetinggenie.styles.RadioGroupContainerStyle)
        ctx.theme.registerStyle("radio-option-label",
                gr.tech.meetinggenie.styles.RadioOptionLabelStyle)
        ctx.theme.registerStyle("radio-input", gr.tech.meetinggenie.styles.RadioInputStyle)
        ctx.theme.registerStyle("table-select", gr.tech.meetinggenie.styles.TableSelectStyle)
        ctx.theme.registerStyle("checkbox-input", gr.tech.meetinggenie.styles.CheckboxInputStyle)
        ctx.theme.registerStyle("checkbox-option-label",
                gr.tech.meetinggenie.styles.CheckboxOptionLabelStyle)
        ctx.theme.registerStyle("top-nav", gr.tech.meetinggenie.styles.TopNavStyle)
        ctx.theme.registerStyle("navbar-brand-title",
                gr.tech.meetinggenie.styles.NavbarBrandTitleStyle)
        ctx.theme.registerStyle("navbar-greeting", gr.tech.meetinggenie.styles.NavbarGreetingStyle)
        ctx.theme.registerStyle("sidebar", gr.tech.meetinggenie.styles.SidebarStyle)
        ctx.theme.registerStyle("sidebar-divider", gr.tech.meetinggenie.styles.SidebarDividerStyle)
        ctx.theme.registerStyle("sidebar-title", gr.tech.meetinggenie.styles.SidebarTitleStyle)
        ctx.theme.registerStyle("sidebar-toggle", gr.tech.meetinggenie.styles.SidebarToggleStyle)
        ctx.theme.registerStyle("sidebar-mobile-backdrop",
                gr.tech.meetinggenie.styles.SidebarMobileBackdropStyle)
        ctx.theme.registerStyle("input-section-title",
                gr.tech.meetinggenie.styles.InputSectionTitleStyle)
        ctx.theme.registerStyle("data-entry-table", gr.tech.meetinggenie.styles.DataEntryTableStyle)
        ctx.theme.registerStyle("data-entry-cell", gr.tech.meetinggenie.styles.DataEntryCellStyle)
        ctx.theme.registerStyle("data-entry-row", gr.tech.meetinggenie.styles.DataEntryRowStyle)
        ctx.theme.registerStyle("data-entry-cell-text",
                gr.tech.meetinggenie.styles.DataEntryCellTextStyle)
        ctx.theme.registerStyle("data-entry-control-cell",
                gr.tech.meetinggenie.styles.DataEntryControlCellStyle)
        ctx.theme.registerStyle("drag-handle", gr.tech.meetinggenie.styles.DragHandleStyle)
        ctx.theme.registerStyle("delete-row-button",
                gr.tech.meetinggenie.styles.DeleteRowButtonStyle)
        ctx.theme.registerStyle("add-row-button", gr.tech.meetinggenie.styles.AddRowButtonStyle)
        ctx.theme.registerKeyframes("gr-loading-spinner",
                gr.tech.meetinggenie.components.widgets.grLoadingSpinnerAnimation)
        ctx.theme.registerKeyframes("modal-overlay-fade-in",
                gr.tech.meetinggenie.styles.ModalOverlayFadeInAnimation)
        ctx.theme.registerKeyframes("modal-content-slide-up",
                gr.tech.meetinggenie.styles.ModalContentSlideUpAnimation)
        gr.tech.meetinggenie.styles.initSiteStyles(ctx)
    }

    router.tryRoutingTo(BasePath.remove(window.location.href.removePrefix(window.origin)),
            UpdateHistoryMode.REPLACE)

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    val root = document.getElementById("_kobweb-root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    renderComposable(rootElementId = "_kobweb-root") {
        gr.tech.meetinggenie.AppEntry {
            router.renderActivePage { DeferringHost { it() } }
        }
    }
}
